module.exports = __webpack_public_path__ + "media/images/photos/3-3af576f2f05022c78171e3a88108e60f.jpg";